import { SET_CONFIG } from '../actions/config';

function config(state = {}, action) {
    switch (action.type) {
        case SET_CONFIG:
            return action.config;

        default:
            return state;
    }
}
export default config;
